import React, { useState } from 'react';
import { AdminListWrapper, TableCell } from 'components/Hospital/PaginationForms';
import { adminAssessmentPaymentListWidth } from 'constants/pagination';
import { AdminAssessmentPaymentPaginationTableProps } from 'models/Admin/AdminPaginationTypes';
import { getWidthRation } from 'utils/calculateWdith';
import { adminAssessmentPaymentPageApi } from 'api/Admin/adminAssessmentPaymentPageApi';
import { useLoginStore } from 'store/useLoginDataStore';
import styled from 'styled-components';
import { Red, Lime } from 'styles/Global/colorPrimitive';
import BasicConfirmModal from 'components/Modal/BasicConfirmModal';

const AdminAssessmentPaymentPaginationTable = ({
    currentData,
    currentPage,
    totalCount,
    onDataUpdate,
}: AdminAssessmentPaymentPaginationTableProps) => {
    const itemsPerPage = 20;
    const { loginData } = useLoginStore();
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [pendingUpdate, setPendingUpdate] = useState<{ id: string; currentIsTest: boolean } | null>(null);

    const handleToggleIsTest = (id: string, currentIsTest: boolean) => {
        setPendingUpdate({ id, currentIsTest });
        setIsConfirmModalOpen(true);
    };

    const handleConfirmUpdate = async () => {
        if (!pendingUpdate) return;
        
        try {
            await adminAssessmentPaymentPageApi.updateAssessmentPayment(
                pendingUpdate.id, 
                !pendingUpdate.currentIsTest, 
                loginData.token
            );
            if (onDataUpdate) {
                onDataUpdate();
            }
        } catch (error) {
            console.error('Failed to update isTest:', error);
        } finally {
            setIsConfirmModalOpen(false);
            setPendingUpdate(null);
        }
    };

    const handleCancelUpdate = () => {
        setIsConfirmModalOpen(false);
        setPendingUpdate(null);
    };

    return (
        <>
            {currentData && currentData.length > 0 ? (
                currentData.map((item, index) => {
                    const itemNumber = totalCount - (currentPage - 1) * itemsPerPage - index;

                    return (
                        <AdminListWrapper key={item._id}>
                            <TableCell $width={getWidthRation(adminAssessmentPaymentListWidth[0])}>
                                {itemNumber}
                            </TableCell>
                            <TableCell $width={getWidthRation(adminAssessmentPaymentListWidth[1])}>
                                {item.hospitalName}
                            </TableCell>
                            <TableCell $width={getWidthRation(adminAssessmentPaymentListWidth[2])}>
                                {item.patientName}
                            </TableCell>
                            <TableCell $width={getWidthRation(adminAssessmentPaymentListWidth[3])}>
                                {item.userTestingNo}
                            </TableCell>
                            <TableCell $width={getWidthRation(adminAssessmentPaymentListWidth[4])}>
                                {item.assessmentCode}
                            </TableCell>
                            <TableCell $width={getWidthRation(adminAssessmentPaymentListWidth[5])}>
                                {item.retailPrice.toLocaleString()}원
                            </TableCell>
                            <TableCell $width={getWidthRation(adminAssessmentPaymentListWidth[6])}>
                                {item.supplyPrice.toLocaleString()}원
                            </TableCell>
                            <TableCell $width={getWidthRation(adminAssessmentPaymentListWidth[7])}>
                                {item.paymentDateTime}
                            </TableCell>
                            <TableCell $width={getWidthRation(adminAssessmentPaymentListWidth[8])}>
                                <ToggleButton 
                                    $isTest={item.isTest}
                                    onClick={() => handleToggleIsTest(item._id, item.isTest)}
                                >
                                    {item.isTest ? '테스트' : '운영'}
                                </ToggleButton>
                            </TableCell>
                        </AdminListWrapper>
                    );
                })
            ) : null}
            {isConfirmModalOpen && pendingUpdate && (
                <BasicConfirmModal
                    title="테스트/운영 변경"
                    content={`${pendingUpdate.currentIsTest ? '운영으로 변경하시겠습니까?' : '테스트로 변경하시겠습니까?'}`}
                    firstButton="취소"
                    secondButton="확인"
                    cancelButton={handleCancelUpdate}
                    confirmButton={handleConfirmUpdate}
                />
            )}
        </>
    );
};

const ToggleButton = styled.button<{ $isTest: boolean }>`
    padding: 6px 12px;
    border: 1px solid ${({ $isTest }) => $isTest ? Red.color_red_600 : Lime.color_lime_600};
    background-color: ${({ $isTest }) => $isTest ? Red.color_red_50 : Lime.color_lime_50};
    color: ${({ $isTest }) => $isTest ? Red.color_red_600 : Lime.color_lime_600};
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    
    &:hover {
        background-color: ${({ $isTest }) => $isTest ? Red.color_red_100 : Lime.color_lime_100};
    }
`;

export default AdminAssessmentPaymentPaginationTable;